const PAGES = {
  playlists: "playlists",
  artist_report: "artist-report",
  earnings: "earnings",
  users: "users",
};
export default PAGES;
